<!-- <p>embargo-delete-modal works!</p> -->
<!-- Embargo Delete Modal -->
<nz-modal
  nzTitle="Delete Selected"
  [(nzVisible)]="showModal"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzWidth]="500"
  (nzOnCancel)="handleCancelForEmbargoDelete()"
>
  <ng-template #modalContent>
    <div class="row-holder">
      <div nzSpan="13">Attention!</div>
      <div nzSpan="11">You are about to delete {{ count }} overrides</div>
      <div nzSpan="11">This Action cannot be undone</div>
      <div nzSpan="11">Are you sure you want to continue?</div>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancelForEmbargoDelete()">
      Cancel
    </button>
    <button nz-button nzType="primary" (click)="handledelete()">Delete</button>
  </ng-template>
</nz-modal>
